import { render, staticRenderFns } from "./AutoPartnerSetting.vue?vue&type=template&id=364c9130&"
import script from "./AutoPartnerSetting.vue?vue&type=script&lang=js&"
export * from "./AutoPartnerSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports